import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {DcpOrderEntryService} from '@app/services/dcp-order-entry.service';
import {FeatureTogglesService, JsonService, LocalStorageService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {KeyValuePair} from '@app/cart/dcp-cart-configuration.model';
import {Observable, first} from 'rxjs';
import {DcpConfigService} from '@app/services/dcp-config.service';
import {DefaultModalService} from '@app/shared/modal/services/default-modal.service';
import {TranslationService} from '@spartacus/core';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';

export const CONFIGURATION_DESCRIPTION: string = 'netPriceDescription';

@UntilDestroy()
@Component({
  selector: 'dcp-cps-price-details-tooltip',
  templateUrl: './cps-price-details-tooltip.component.html',
  styleUrls: ['./cps-price-details-tooltip.component.scss']
})
export class CpsPriceDetailsTooltipComponent implements OnInit {
  @Input() entry: OrderEntry;
  priceTooltipItems: KeyValuePair<any>;
  showConfigurationDescription: boolean = true;
  commercialModelShowTooltipBreakdown: boolean = true;
  showTooltipPriceCalculationBreakdown$: Observable<boolean>;
  subtotals: any[] = [];
  modalTitleKey: string = 'cartItems.priceTooltip.header';
  modalTitleValue: string;
  modalId: string;
  @ViewChild('modalContentTemplate') modalContentTemplate: TemplateRef<any>;

  constructor(
    public dcpOrderEntryService: DcpOrderEntryService,
    private localStorageService: LocalStorageService,
    private jsonService: JsonService,
    private featureTogglesService: FeatureTogglesService,
    private dcpConfigService: DcpConfigService,
    private modalService: DefaultModalService,
    private translationService: TranslationService,
  ) {
  }

  ngOnInit(): void {
    this.initFeatureToggles();
    this.initTtConfig();
    this.priceTooltipItems = this.jsonService.parseSafely(this.localStorageService.getItem(this.entry.product.code));
    this.checkForPriceDescription();
    this.loadSubtotals();
  }

  openModal() {
    this.translationService.translate(this.modalTitleKey)
      .pipe(first(), untilDestroyed(this))
      .subscribe((translation) => {
        this.modalTitleValue = translation;
    });
    this.modalId = this.modalService.openModal(this.modalContentTemplate, this.modalTitleValue);
  }

  closeModal() {
    this.modalService.closeModal(this.modalId);
  }

  checkForPriceDescription() {
    this.showConfigurationDescription = !!this.priceTooltipItems?.some(item => !!item[CONFIGURATION_DESCRIPTION]);
  }

  loadSubtotals(): void {
    this.subtotals = this.dcpOrderEntryService.getPriceCalculationBreakdownFromSubtotals(this.entry, this.entry.product.code);
  }

  private initFeatureToggles() {
    this.showTooltipPriceCalculationBreakdown$ = this.featureTogglesService.isEnabled(UNLEASH_TOGGLES.pricingTooltipPriceCalculationBreakdown);
  }

  private initTtConfig() {
    const currentBundleTemplate = this.dcpOrderEntryService.getBundleTemplate(this.entry);
    this.dcpConfigService.getCommercialModelConfig(this.entry.product, this.entry.transactionType, currentBundleTemplate)
      .pipe(untilDestroyed(this))
      .subscribe(commercialModelConfig => {
        this.commercialModelShowTooltipBreakdown = !commercialModelConfig.hideTooltipPriceCalculationBreakdown;
      });
  }
}
